import { useMemo } from 'react';

import useFormContext from './useFormContext';

export default () => {
    const { state } = useFormContext();
    return useMemo(() => {
        return (
            state.receiver?.name !== state.chosenReceiver?.name ||
            state.receiver?.address !== state.chosenReceiver?.address ||
            state.receiver?.address2 !== state.chosenReceiver?.address2 ||
            state.receiver?.postcode !== state.chosenReceiver?.postcode ||
            state.receiver?.town !== state.chosenReceiver?.town ||
            state.receiver?.receiverCountryCode?.value !== state.chosenReceiver?.countryCode?.value
        );
    }, [state]);
};
